import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SidebarCollapseState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

/**
 * Open/closed state for the workspace sidebar rail. Persisted to
 * localStorage so the choice survives reloads. Lives in the
 * repositories layer per AGENTS.md ("state (Zustand stores)"),
 * next to the command-palette store.
 */
export const useSidebarCollapsed = create<SidebarCollapseState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    {
      name: 'voll.sidebar.collapsed',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ collapsed: s.collapsed }),
    },
  ),
);
